import { render, staticRenderFns } from "./NewAgentRegistrationForm.vue?vue&type=template&id=065e44ea"
import script from "./NewAgentRegistrationForm.vue?vue&type=script&lang=js"
export * from "./NewAgentRegistrationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports